<template>
    <div>

    </div>
</template>

<script>
export default {

  name: 'show',

  data () {
    return {

    }
  }
}
</script>


